import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  DiGit,
} from "react-icons/di";
import {
  SiDocker,
  SiLinux,
  SiMongodb,
 SiPostgresql,
} from "react-icons/si";
import "./about.css";

function Toolstack() {
  return (
    <div>
      {/* Tool Stack */}
      
      <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
        <Col xs={4} md={2} className="tech-icons">
          <SiDocker />
          <div className="tech-label">Docker</div>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <SiLinux />
          <div className="tech-label">Linux</div>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <SiMongodb />
          <div className="tech-label">MongoDB</div>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <DiGit />
          <div className="tech-label">Git</div>
        </Col>
	<Col xs={4} md={2} className="tech-icons">
	<SiPostgresql />
          <div className="tech-label">PostgreSQL</div>
        </Col>

      </Row>
    </div>
  );
}

export default Toolstack;

